const ACCESS_TOKEN_KEY = 'nibni_access_token';

export function readStoredAccessToken(): string | null {
    if (typeof window === 'undefined') return null;
    try {
        const raw = window.sessionStorage.getItem(ACCESS_TOKEN_KEY);
        return raw && raw.trim() ? raw.trim() : null;
    } catch {
        return null;
    }
}

export function writeStoredAccessToken(token: string | null | undefined): void {
    if (typeof window === 'undefined') return;
    try {
        if (!token) {
            window.sessionStorage.removeItem(ACCESS_TOKEN_KEY);
            return;
        }
        window.sessionStorage.setItem(ACCESS_TOKEN_KEY, String(token));
    } catch {
        // ignore storage failures
    }
}

